module.exports = __webpack_public_path__ + "img/footer-logo2.3187a15e.png";